import { render, staticRenderFns } from "./WorkOnDocument.vue?vue&type=template&id=1a834ffc&scoped=true&"
import script from "./WorkOnDocument.ts?vue&type=script&lang=ts&"
export * from "./WorkOnDocument.ts?vue&type=script&lang=ts&"
import style0 from "./WorkOnDocument.vue?vue&type=style&index=0&id=1a834ffc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a834ffc",
  null
  
)

export default component.exports
import {QSpinnerGears,QBtn,QTooltip,QSpinner,QMenu,QDialog,QCard,QLinearProgress,QCardSection,QInput,QField} from 'quasar'
component.options.components = Object.assign({QSpinnerGears,QBtn,QTooltip,QSpinner,QMenu,QDialog,QCard,QLinearProgress,QCardSection,QInput,QField}, component.options.components || {})
